import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'dcc-cohort-search-input',
  templateUrl: './cohort-search-input.component.html',
  styleUrls: ['./cohort-search-input.component.scss'],
})
export class CohortSearchInputComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() placeHolder: string;
  @Input() name: string;

  @Output() wordTyped: EventEmitter<string> = new EventEmitter<string>();

  inputValue: string;

  private searchSubject = new Subject<string>();
  private subscription: Subscription;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cohortName']) {
      this.inputValue = this.name;
    }
  }

  ngOnInit(): void {
    this.inputValue = this.name;
    this.subscription = this.searchSubject
      .pipe(debounceTime(200)) // Debounce for 200ms
      .subscribe((searchTerm: string) => {
        this.wordTyped.emit(searchTerm); // Emit the debounced value
      });
  }

  onInput(): void {
    this.searchSubject.next(this.inputValue);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
